import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import type { Tag } from '@/lib/data/types';

interface RelatedTagsProps {
  tags: Tag[];
}

const RelatedTags = ({ tags }: RelatedTagsProps) => {
  const t = useTranslations('common');

  if (!tags.length) {
    return null;
  }

  return (
    <div className="border rounded-5 p-4 mb-4" style={{ borderColor: '#777E90' }}>
      <h5>{t('playlists.sectionHeadings.relatedTags')}</h5>
      <ul className="list-unstyled m-0 d-flex flex-wrap">
        {tags.map((tag) => (
          <li className="m-1" key={tag.slug}>
            <Link
              href={`/playlists/tags/${tag.slug}`}
              className="btn border rounded-5 btn-outline-secondary"
              style={{ borderColor: '#353945' }}
            >
              #{tag.name.toUpperCase()}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RelatedTags; 